var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTermsAndConditions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.168,
    height: 24.102,
    viewBox: "0 0 20.168 24.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M16.751,13.768a.983.983,0,0,1-.983.983H7.9a.983.983,0,1,1,0-1.967h7.867A.983.983,0,0,1,16.751,13.768Zm-3.934,2.95H7.9a.983.983,0,0,0,0,1.967h4.917a.983.983,0,0,0,0-1.967Zm8.851-6.407v8.374A4.923,4.923,0,0,1,16.751,23.6H6.917A4.923,4.923,0,0,1,2,18.685V4.917A4.923,4.923,0,0,1,6.917,0h4.44a6.842,6.842,0,0,1,4.868,2.016l3.426,3.428a6.836,6.836,0,0,1,2.017,4.867Zm-6.834-6.9A4.927,4.927,0,0,0,13.8,2.639V6.884a.983.983,0,0,0,.983.983h4.244a4.9,4.9,0,0,0-.768-1.033Zm4.867,6.9c0-.162-.031-.318-.046-.477H14.784a2.95,2.95,0,0,1-2.95-2.95V2.013c-.159-.015-.316-.046-.477-.046H6.917a2.95,2.95,0,0,0-2.95,2.95V18.685a2.95,2.95,0,0,0,2.95,2.95h9.834a2.95,2.95,0,0,0,2.95-2.95Z",
    transform: "translate(-1.75 0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsAndConditions);
export default __webpack_public_path__ + "static/media/termsAndConditions.fd1b98f592a07b1c35c29b133a7be2db.svg";
export { ForwardRef as ReactComponent };